/**
 * DESKTOP DRAWER CONTROL - MINU&BABY
 */

// Detectar si estamos en la home y añadir clase al body
if (window.location.pathname === '/' || window.location.pathname === '') {
  document.body.classList.add('is-homepage');
}

(function() {
  'use strict';
  
  if (window.innerWidth < 990) return;
  
  const drawer = document.getElementById('desktop-drawer-navigation');
  const overlay = document.getElementById('desktop-drawer-overlay');
  const closeBtn = document.getElementById('desktop-drawer-close');
  const body = document.body;
  let hamburgerBtn = document.getElementById('desktop-hamburger-btn');
  
  if (!drawer || !overlay) {
    console.warn('Desktop Drawer: Elementos no encontrados');
    return;
  }
  
  let isOpen = false;
  
  function openDrawer() {
    isOpen = true;
    drawer.classList.add('is-open');
    overlay.classList.add('is-visible');
    body.classList.add('desktop-drawer-open');
  }
  
  function closeDrawer() {
    isOpen = false;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    body.classList.remove('desktop-drawer-open');
    
    const expandedItems = drawer.querySelectorAll('.desktop-drawer-item.is-expanded');
    expandedItems.forEach(item => item.classList.remove('is-expanded'));
  }
  
  function toggleDrawer(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (isOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }
  
  function toggleSubmenu(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const item = e.currentTarget.closest('.desktop-drawer-item');
    if (!item) return;
    
    const wasExpanded = item.classList.contains('is-expanded');
    const parent = item.parentElement;
    const siblings = parent.querySelectorAll(':scope > .desktop-drawer-item.is-expanded');
    siblings.forEach(sibling => {
      if (sibling !== item) {
        sibling.classList.remove('is-expanded');
      }
    });
    
    item.classList.toggle('is-expanded', !wasExpanded);
  }
  
  function initializeEvents() {
    if (!hamburgerBtn) return;
    
    hamburgerBtn.addEventListener('click', toggleDrawer);
    
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeDrawer();
      });
    }
    
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeDrawer();
      }
    });
    
    const toggleButtons = drawer.querySelectorAll('[data-toggle-submenu]');
    toggleButtons.forEach(btn => {
      btn.addEventListener('click', toggleSubmenu);
    });
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) {
        closeDrawer();
      }
    });
    
    drawer.addEventListener('click', function(e) {
      e.stopPropagation();
    });
    
    document.addEventListener('click', function(e) {
      if (isOpen && !drawer.contains(e.target) && !hamburgerBtn.contains(e.target)) {
        closeDrawer();
      }
    });
    
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth < 990 && isOpen) {
          closeDrawer();
        }
      }, 250);
    });
    
    // Scroll handling - Detecta tipo de página
      let lastScroll = 0;
      window.addEventListener('scroll', function() {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        
        if (currentScroll > 50) {
          document.body.classList.add('header-is-sticky');
        } else {
          document.body.classList.remove('header-is-sticky');
        }
        
        lastScroll = currentScroll;
    });
    
    console.log('✅ Desktop Drawer inicializado correctamente');
  }
  
  // Intentar inicializar
  if (hamburgerBtn) {
    initializeEvents();
  } else {
    console.warn('⚠️ Botón hamburguesa no encontrado, reintentando...');
    setTimeout(function() {
      hamburgerBtn = document.getElementById('desktop-hamburger-btn');
      if (hamburgerBtn) {
        initializeEvents();
      } else {
        console.error('❌ Botón hamburguesa no encontrado');
      }
    }, 500);
  }
  
})();
